import {
  getExpandedProjects,
  setExpandedProjects as saveExpandedProjects,
} from "@/lib/uiStatePersistence";
import { useCallback, useEffect, useState } from "react";

/**
 * Custom hook to manage which projects are expanded in the sidebar
 * with localStorage persistence across page refreshes
 */
export function useExpandedProjects() {
  const [expandedProjects, setExpandedProjects] = useState<Set<string>>(() => {
    return getExpandedProjects();
  });

  // Save to localStorage whenever expandedProjects changes
  useEffect(() => {
    saveExpandedProjects(expandedProjects);
  }, [expandedProjects]);

  // Toggle a project's expanded state
  const toggleProject = useCallback((projectId: string) => {
    setExpandedProjects((prev) => {
      const next = new Set(prev);
      if (next.has(projectId)) {
        next.delete(projectId);
      } else {
        next.add(projectId);
      }
      return next;
    });
  }, []);

  return {
    expandedProjects,
    toggleProject,
  };
}
